import { CustomFieldDataType, alphabeticalCompare } from '@cims-online/shared'
import {
  DateValue,
  NumberValue,
  TextValue,
  WithRenderedCustomFields,
} from '../../../types'
import { find } from './find'
import { CIMSSingleColumn } from '../../../../CIMSTable/CIMSColumn/types'

export function sortOptions<T extends WithRenderedCustomFields>({
  customFieldId,
  dataTypeId,
}: SortOptions): CIMSSingleColumn<T>['sort'] | undefined {
  const value = (
    record: T,
    key: 'dateValues' | 'numberValues' | 'textValues'
  ) =>
    find<DateValue | NumberValue | TextValue>(
      record?.customFields?.[key],
      customFieldId
    )?.value
  if (dataTypeId === CustomFieldDataType.Date.id)
    return {
      with: 'callback',
      onCompare: (a, b) =>
        alphabeticalCompare(value(a, 'dateValues'), value(b, 'dateValues')),
    }
  else if (dataTypeId === CustomFieldDataType.Number.id)
    return {
      with: 'callback',
      onCompare: (a, b) =>
        alphabeticalCompare(value(a, 'numberValues'), value(b, 'numberValues')),
    }
  else if (dataTypeId === CustomFieldDataType.Text.id)
    return {
      with: 'callback',
      onCompare: (a, b) =>
        alphabeticalCompare(value(a, 'textValues'), value(b, 'textValues')),
    }
  else return undefined
}

type SortOptions = {
  customFieldId: string
  dataTypeId: string
}
